import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';
import './Alert.css';

export type AlertVariant = 'critical' | 'error' | 'warning' | 'success' | 'info';

export interface AlertProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  variant?: AlertVariant;
  /** Título do alerta. No `critical` é renderizado em negrito + sublinhado. */
  title?: ReactNode;
  icon?: ReactNode;
}

/**
 * Alerta de destaque. `critical` é o aviso de guarda da palavra-chave/passphrase
 * pedido na ata 2026-06-01: vermelho + negrito + sublinhado. Sempre role="alert".
 */
export function Alert({
  variant = 'info',
  title,
  icon,
  className,
  children,
  ...rest
}: AlertProps): JSX.Element {
  return (
    <div className={cn('cf-alert', `cf-alert--${variant}`, className)} role="alert" {...rest}>
      {icon && (
        <span className="cf-alert__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <div className="cf-alert__body">
        {title && <div className="cf-alert__title">{title}</div>}
        {children && <div className="cf-alert__text">{children}</div>}
      </div>
    </div>
  );
}
